import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import * as _ from 'lodash';
import { EmojiServiceService } from '../services/emoji-service.service';
import { StorageService } from '../services/storage.service';
import { LocaleService } from '../services/locale.service';
import { GeoService } from '../services/geo.service';

@Component({
  selector: 'app-endGame',
  templateUrl: './endGame.component.html',
  styleUrls: ['./endGame.component.scss']
})
export class EndGameComponent implements OnInit {
  players = [];
  bgColor;
  loaders = {
    refresh: false
  }
  groupId;
  activeGame;
  pageConfig = {
    gameId: null,
    playerId: null,
    activeTab: 'leaderboard'
  };
  locales = {
    hallOfFame: this.localeService.getTrans('Hall of fame'),
    congrats: this.localeService.getTrans('Congrats! The game has ended!'),
    byDistance: this.localeService.getTrans('By Distance'),
    byPoints: this.localeService.getTrans('By points'),
  }
  constructor( 
    private route: ActivatedRoute,
    private router: Router, 
    private http: HttpClient,
    public localeService: LocaleService,
    private geoService: GeoService,
    public emojiService: EmojiServiceService, private storageService: StorageService) {
      if (this.route.snapshot.paramMap.get('g') && this.route.snapshot.paramMap.get('p')) {
        this.storageService.removeStorage('fl_storage');
        this.pageConfig.gameId = this.route.snapshot.paramMap.get('g');
        this.pageConfig.playerId = this.route.snapshot.paramMap.get('p');
        this.groupId = this.route.snapshot.paramMap.get('groupId');
        this.getGame(this.route.snapshot.paramMap.get('g'), this.route.snapshot.paramMap.get('p'));
      } else{
        this.navigateBack();
      } 
  }
  refresh(){
    if(this.pageConfig.activeTab === 'leaderboard'){
      this.getGame(this.route.snapshot.paramMap.get('g'), this.route.snapshot.paramMap.get('p'));
    } else{
      this.getDistance(this.route.snapshot.paramMap.get('g'));
    }
  }

  navigateToCustomRedirectURL(){
    if(this.activeGame.tourId && this.activeGame.tourId.customRedirectURL){
      window.location.href = this.activeGame.tourId.customRedirectURL;
    }
  }

  navigateToRelive(){
    console.log(this.route.snapshot.paramMap.get("g"))
      window.location.href = environment.portalUrl + 'relive/' + this.route.snapshot.paramMap.get("g");
  }

  setTab(activeTab){
    this.pageConfig.activeTab = activeTab;
    if(this.pageConfig.activeTab === 'leaderboard'){
      this.getGame(this.route.snapshot.paramMap.get('g'), this.route.snapshot.paramMap.get('p'));
    } else{
      this.getDistance(this.route.snapshot.paramMap.get('g'));
    }
  }

   share(){
    if (navigator.share) {
      navigator.share({
        title: 'Flinkit! Outdoor! | Leaderboard',
        url: window.location.href
      }).then(() => {
        
      })
      .catch(console.error);
    } else {
      console.log('Share is not supported')
    }
  }

  getDistance(gameId){
    this.loaders.refresh = true;
    return this.http.post(environment.baseUrl + 'games/getDistanceByGame', {gameId, groupId: this.route.snapshot.paramMap.get('groupId')} ).subscribe((data: any) => {
      this.loaders.refresh = false;
      if(data.success){
        console.log(data)
         this.players = _.orderBy(data.data, ['distance'], ['desc']);
         console.log(this.players)
      } else{
        this.navigateBack()
      }
    }); 
  }

  getGame(gameId, player){
    return this.http.post(environment.baseUrl + 'games/getGameRes', {groupId: this.groupId} ).subscribe((data: any) => {
     if(data.success){
      console.log(data)
        this.activeGame = data.game;
        this.activeGame.partner = data.partner;
        this.players = _.orderBy(data.players, ['points'], ['desc']);
        // Only use custom colors if white label is enabled
        if (this.activeGame.partner?.isWhiteLabel) {
          // White label enabled - check for custom branding, then partner color, fallback to purple
          this.bgColor = (this.activeGame.tourId?.isCustomBranding && this.activeGame.tourId.customBranding?.color) 
            ? this.activeGame.tourId.customBranding.color 
            : (this.activeGame.partner?.color || '#4e3b74');
        } else {
          // Not white label - always use Flinkit purple
          this.bgColor = '#4e3b74';
        }

     } else{
       this.navigateBack()
     }
   }); 
 }


  navigateBack() {
    this.router.navigate(['/']);
  }

  ngOnInit() {
    this.storageService.removeStorage('fl-game-details');
    setTimeout(()=>{
      this.geoService.dropConfetti();
    },1000)
  }

}
